const RADIUS_BASE_PX = 6;
const RADIUS_MAX_PX = 11;
const SIZE_RANK_GAMMA = 2.5;

function radiusFromPremiumRank(t: number): number {
  const clamped = Math.min(Math.max(t, 0), 1);
  const emphasis = Math.pow(clamped, SIZE_RANK_GAMMA);
  return RADIUS_BASE_PX + emphasis * (RADIUS_MAX_PX - RADIUS_BASE_PX);
}

export function notableOptionTradeDiamondRadiusByKey(
  rows: Array<{ key: string; premium: number }>,
): Map<string, number> {
  const out = new Map<string, number>();
  const valid = rows.filter((r) => r.premium > 0);
  const n = valid.length;
  if (n === 0) return out;
  if (n === 1) {
    out.set(valid[0].key, RADIUS_BASE_PX);
    return out;
  }
  const sorted = [...valid].sort((a, b) => {
    const d = a.premium - b.premium;
    return d !== 0 ? d : a.key.localeCompare(b.key);
  });
  let i = 0;
  while (i < n) {
    let j = i + 1;
    while (j < n && sorted[j].premium === sorted[i].premium) j += 1;
    const lo = i;
    const hi = j - 1;
    const avgRank = (lo + hi) / 2;
    const t = avgRank / (n - 1);
    const r = radiusFromPremiumRank(t);
    for (let k = i; k < j; k += 1) out.set(sorted[k].key, r);
    i = j;
  }
  return out;
}

export function notableOptionTradeDiamondRadiusFallback(premium: number): number {
  const p = Math.max(premium, 1);
  return Math.min(RADIUS_BASE_PX + Math.log10(p / 25_000) * 1.8, RADIUS_MAX_PX);
}
